// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { EventFilter, EventFilterT, verifyEventFilter } from "./event-filter";
import { NodeId, NodeIdT, verifyNodeId } from "./node-id";

/**
 * Subscribe to events on an event-notifier node.
 */
export class EventMonitor implements flatbuffers.IUnpackableObject<EventMonitorT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EventMonitor {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEventMonitor(bb: flatbuffers.ByteBuffer, obj?: EventMonitor): EventMonitor {
    return (obj || new EventMonitor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsEventMonitor(
    bb: flatbuffers.ByteBuffer,
    obj?: EventMonitor,
  ): EventMonitor {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EventMonitor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Event notifier node (e.g. the Server object, ns=0;i=2253).
   */
  nodeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  filter(obj?: EventFilter): EventFilter | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new EventFilter()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Subscription name this event monitor is grouped under.
   */
  subscriptionName(): string | null;
  subscriptionName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  subscriptionName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  queueSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 1000;
  }

  static startEventMonitor(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addNodeId(builder: flatbuffers.Builder, nodeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeIdOffset, 0);
  }

  static addFilter(builder: flatbuffers.Builder, filterOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, filterOffset, 0);
  }

  static addSubscriptionName(
    builder: flatbuffers.Builder,
    subscriptionNameOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, subscriptionNameOffset, 0);
  }

  static addQueueSize(builder: flatbuffers.Builder, queueSize: number) {
    builder.addFieldInt32(3, queueSize, 1000);
  }

  static endEventMonitor(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_id
    builder.requiredField(offset, 6); // filter
    return offset;
  }

  unpack(): EventMonitorT {
    return new EventMonitorT(
      this.nodeId() !== null ? this.nodeId()!.unpack() : null,
      this.filter() !== null ? this.filter()!.unpack() : null,
      this.subscriptionName(),
      this.queueSize(),
    );
  }

  unpackTo(_o: EventMonitorT): void {
    _o.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    _o.filter = this.filter() !== null ? this.filter()!.unpack() : null;
    _o.subscriptionName = this.subscriptionName();
    _o.queueSize = this.queueSize();
  }

  unpackFields(...fields: string[]): EventMonitorT {
    const t = new EventMonitorT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_id")) {
      t.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    }
    if (fieldSet.has("filter")) {
      t.filter = this.filter() !== null ? this.filter()!.unpack() : null;
    }
    if (fieldSet.has("subscription_name")) {
      t.subscriptionName = this.subscriptionName();
    }
    if (fieldSet.has("queue_size")) {
      t.queueSize = this.queueSize();
    }
    return t;
  }
}

export class EventMonitorT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodeId: NodeIdT | null = null,
    public filter: EventFilterT | null = null,
    public subscriptionName: string | Uint8Array | null = null,
    public queueSize: number = 1000,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeId === null || this.nodeId === undefined) {
      throw new Error('Required field "node_id" is not set');
    }
    if (this.filter === null || this.filter === undefined) {
      throw new Error('Required field "filter" is not set');
    }
    const nodeId = this.nodeId !== null ? this.nodeId!.pack(builder) : 0;
    const filter = this.filter !== null ? this.filter!.pack(builder) : 0;
    const subscriptionName =
      this.subscriptionName !== null ? builder.createString(this.subscriptionName!) : 0;

    EventMonitor.startEventMonitor(builder);
    EventMonitor.addNodeId(builder, nodeId);
    EventMonitor.addFilter(builder, filter);
    EventMonitor.addSubscriptionName(builder, subscriptionName);
    EventMonitor.addQueueSize(builder, this.queueSize);

    return EventMonitor.endEventMonitor(builder);
  }

  clone(): EventMonitorT {
    const obj = new EventMonitorT();
    obj.nodeId = this.nodeId !== null ? this.nodeId!.clone() : null;
    obj.filter = this.filter !== null ? this.filter!.clone() : null;
    obj.subscriptionName = this.subscriptionName;
    obj.queueSize = this.queueSize;
    return obj;
  }

  equals(other: EventMonitorT): boolean {
    if (this.nodeId !== null && other.nodeId !== null) {
      if (!this.nodeId!.equals(other.nodeId!)) return false;
    } else if (this.nodeId !== other.nodeId) return false;
    if (this.filter !== null && other.filter !== null) {
      if (!this.filter!.equals(other.filter!)) return false;
    } else if (this.filter !== other.filter) return false;
    if (this.subscriptionName !== other.subscriptionName) return false;
    if (this.queueSize !== other.queueSize) return false;
    return true;
  }
}

export function verifyEventMonitor(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyEventFilter(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "filter");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 4);
  } finally {
    verifier.popDepth();
  }
}
